import { useEffect, useRef } from 'react';

/**
 * [useFocus]: focus on element without user needing to click on element or tab to element
 * creates MutableRefObject and sets focus to the ref
 * @returns MutableRefObject
 */
export const useFocus = () => {
  const elementRef = useRef(null);

  useEffect(() => {
    elementRef.current.focus();
  }, [elementRef]);

  return elementRef;
};
